import { Provider } from '@angular/core';

import { FileValidationService } from '@file-upload/services/file-validation.service';
import { FilesStateService } from '@file-upload/services/files-state.service';
import { FilesService } from '@file-upload/services/files.service';

export const FILE_UPLOAD_PROVIDERS: Provider[] = [
  FilesService,
  FilesStateService,
  FileValidationService
];
